(() => {
  if (window.EverSilkyOrderPricing) return;
  const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
  const textMoney = value => `$${value.toFixed(2)}`;
  const nonnegative = value => Number.isFinite(Number(value)) ? Math.max(0, Number(value)) : 0;
  const taxNote = 'International orders may include local import duties and taxes, which are not included in this price.';

  function getTotals(engine, result = engine.lastResult) {
    if (!engine.shoppingList.length && !result?.valid) return null;
    const order = engine.shoppingList.length ? engine.getShoppingListTotals() : { subtotal: result.subtotal, shipping: result.shippingFee };
    const productTotal = nonnegative(order.subtotal);
    const shipping = nonnegative(order.shipping);
    const subtotal = productTotal + shipping;
    // A single order allowance, after shipping and before payment-method savings.
    // Cap it at the subtotal so an admin-entered amount cannot create a credit.
    const importSupport = Math.min(subtotal, nonnegative(engine.settings.importSupportAmount ?? 15));
    return { productTotal, shipping, subtotal, importSupport, finalCost: subtotal - importSupport };
  }

  function footnote(totals) {
    return `*Final cost includes a ${money(totals.importSupport)} Import Support discount from EverSilkyWigs.\n${taxNote}`;
  }

  function render(root, totals) {
    for (const field of ['productTotal', 'shipping', 'subtotal', 'importSupport', 'finalCost']) {
      for (const node of root.querySelectorAll?.(`[data-order-amount="${field}"]`) || []) {
        const amount = totals && (field === 'finalCost' ? Math.ceil(totals.finalCost) : totals[field]);
        node.textContent = totals ? `${field === 'importSupport' ? '−' : ''}${money(amount)}${field === 'finalCost' ? '*' : ''}` : '—';
      }
    }
    for (const node of root.querySelectorAll?.('[data-order-footnote]') || []) {
      node.hidden = !totals;
      node.textContent = totals ? footnote(totals) : '';
    }
  }

  function summaryLines(engine, separator) {
    const totals = getTotals(engine);
    if (!totals) return [];
    const payment = engine.getPaymentOptionTotals(totals.finalCost);
    return [
      `Product Total: ${textMoney(totals.productTotal)}`,
      `Shipping: ${textMoney(totals.shipping)}`,
      separator,
      `Subtotal: ${textMoney(totals.subtotal)}`,
      `Import Support: -${textMoney(totals.importSupport)}`,
      separator,
      `Your Final Cost: ${textMoney(payment.paypal)}*`,
      footnote(totals),
      separator,
      `Option 1 (PayPal): ${textMoney(payment.paypal)}`,
      `Option 2 (Bank Transfer - ${Number(payment.discounts.bank.toFixed(2))}% Off): ${textMoney(payment.bank)}`
    ];
  }

  window.EverSilkyOrderPricing = { getTotals, render, footnote, summaryLines };
})();
